import { CsatPrompt } from './CsatPrompt'
import { useCsatWatcher } from './useCsatWatcher'

// Componente global: executa o watcher de decisão e renderiza o prompt ativo.
// Deve ser montado uma vez dentro do contexto de evento autenticado.
export const CsatWatcher = () => {
  useCsatWatcher()

  return <CsatPrompt />
}
